exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".menu-name[data-v-252013d0]{height:30px;line-height:13px;font-size:11px;position:relative;font-weight:600;display:block;width:60px;text-align:center;text-transform:capitalize;white-space:normal}.q-layout-footer .q-tabs .q-tab[data-v-252013d0]{padding:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-252013d0","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/Footer.vue
// module id = d+HY
// module chunks = 80